<div class="container_dati_generali">
  <div class="container_tab_nav" >
    <!-- <ul class="nav nav-tabs four">
      <li *ngFor="let tipoScadenza of tipiScadenzeTabs" [style.width.%]="100 / tipiScadenzeTabs.length"
        class="active" id="ts-{{ tipoScadenza.id }}"
        data-toggle="tab" (click)="filterScadenza(tipoScadenza.id)">
        <a>{{ tipoScadenza.label }}</a>
      </li>
    </ul> -->

      <ul class="att_completare">
        <div class="row filtra_scadenzario">
          <p class="col-sm-3 cerca_visualizza">
            <label for="cerca-ademp-list">Cerca</label> <input id="cerca-ademp-list" type="text"
              #searchItem (keyup)="0" class="form-control"
              placeholder="Inserisci appunto" />
          </p>
          <p class="col-sm-3 col-md-offset-6">
            <label for="visualizza-lbl">Visualizza</label> <select
              #filterTermValue id="visualizza-lbl" class="form-control" name="filtroStato" (ngModelChange)="filtraStato($event)" [(ngModel)]="filtroStato" [ngModelOptions]="{standalone: true}">
              <option selected="selected" value="tutti">Tutti</option>
              <option value="evase">Evase</option>
              <option value="inevase">Inevase</option>
              <option value="daEvadere">Da Evadere</option>
            </select>
          </p>
        </div>
        <li *ngFor="let scadenza of scadenzeFiltrate | searchFilter : searchItem.value : 'appunto'; let i = index">

          <div class="tipo_adempimento">

              <p class="{{
                  (scadenza.tipoScadenza?.descrizione | lowercase) &&
                  (scadenza.tipoScadenza?.descrizione | lowercase).indexOf(
                    'attivit'
                  ) == 0
                    ? 'attivita'
                    : (scadenza.tipoScadenza?.descrizione | lowercase)
                }}">
                {{ scadenza.tipoScadenza?.label }}
                <span class="glyphicon glyphicon-exclamation-sign" [ngClass]="{
                    red: scadenza.priorita?.label == 'ALTA',
                    yellow: scadenza.priorita?.label == 'MEDIA',
                    green: scadenza.priorita?.label == 'BASSA'
                  }"></span>
                <span class="{{ scadenza.priorita?.label | lowercase }}">{{
                  scadenza.priorita?.label
                  }}</span>
                <span style="display: block">{{ scadenza.motivo?.label }}</span>
              </p>
            <div style="position: absolute; top: 10px; left: 28%">
              <div *ngIf="scadenza.tipoScadenza?.id === 'UDIENZA' && scadenza?.note" [appTooltip]="scadenza?.note" [appTooltipEnabled]="!!scadenza?.note && scadenza?.note.length > 10" class="custom-option">
                <strong>Note: </strong>{{ truncate(scadenza?.note, 20) || '-'}}
              </div>
              <div *ngIf="scadenza.tipoScadenza?.id === 'UDIENZA' && scadenza?.dettaglioEsitoAdempimento?.esitoDescrizione" [appTooltip]="scadenza?.dettaglioEsitoAdempimento?.esitoDescrizione" [appTooltipEnabled]="!!scadenza?.dettaglioEsitoAdempimento?.esitoDescrizione && scadenza?.dettaglioEsitoAdempimento?.esitoDescrizione.length > 10" class="custom-option">
                <strong>Esito: </strong>{{ truncate(scadenza?.dettaglioEsitoAdempimento?.esitoDescrizione, 20) || '-'}}
              </div>
            </div>


            <div class="data_opzioni scadenze">
              <ul>
                <ng-template [ngIf]="!scadenza.evasa && scadenza.giorniRitardo">
                  <li class="stato_scadenze inevasa">inevasa</li>
                </ng-template>
                <ng-template [ngIf]="!scadenza.evasa && !scadenza.giorniRitardo">
                  <li class="stato_scadenze da_evadere">da evadere</li>
                </ng-template>
                <ng-template [ngIf]="scadenza.evasa">
                  <li class="stato_scadenze evasa">evasa</li>
                </ng-template>
                <li>{{ scadenza.dataScadenza |
                  dateformatter:'DD/MM/YYYY HH:mm'}}</li>
                <!-- 										<li>{{ scadenza.ora }}</li> -->

                  <li *ngIf="writable" class="opzioni" appDropdownFocus><a class="dropdown-toggle" data-toggle="dropdown" href="#" role="button"
                      aria-haspopup="true" aria-expanded="false">Opzioni<span
                        class="glyphicon glyphicon-option-vertical"></span></a>
                    <div class="dropdown-menu">
                      <ul>
                        <li *ngIf="!scadenza.evasa"><span class="glyphicon glyphicon-ok"></span> <a
                            href="javascript:void(0)" (click)="onClickDropDownEvent({eventType: 'evadi', scadenza: scadenza, index: i})">Evadi</a></li>

                        <li *ngIf="!scadenza.evasa"><span class="glyphicon glyphicon-share-alt"></span> <a
                            href="javascript:void(0)" (click)="onClickDropDownEvent({eventType: 'rinvio', scadenza: scadenza, index: i})">Rinvia</a></li>

                        <li><span class="glyphicon glyphicon-paperclip"></span> <a href="javascript:void(0);"
                            (click)="onClickDropDownEvent({eventType: 'allegato', scadenza: scadenza, index: i})">Allega
                            documento</a></li>

                        <li><span class="glyphicon glyphicon-trash"></span> <a href="javascript:void(0)"
                            (click)="onClickDropDownEvent({eventType: 'elimina', scadenza: scadenza, index: i})">Elimina</a></li>

                        <li *ngIf="scadenza.tipoScadenza?.id === 'UDIENZA' && !scadenza.dettaglioEsitoAdempimento"><span
                          class="glyphicon glyphicon-plus"></span> <a
                          href="javascript:void(0)" (click)="onClickDropDownEvent({eventType: 'aggiungiEsitoUdienza', scadenza: scadenza, index: i})">Aggiungi Esito Udienza</a></li>
                      </ul>
                    </div>
                  </li>
                    <a
                      href="#"
                      role="button"
                      class="{{activeIndex === i ? 'accordion-collapse' : 'accordion-collapsed'}} mt-toggle"
                      [class.accordion-collapse]="activeIndex === i"
                      [class.accordion-collapsed]="activeIndex !== i"
                      [attr.aria-expanded]="activeIndex === i"
                      [attr.aria-controls]="'subcontroparteModalAdd' + i"
                      id="accordion-header-adempimenti-{{i}}"
                      (click)="openDetail(scadenza, i); $event.preventDefault()">
                        <span aria-live="polite" class="sr-only">{{ activeIndex === i ? 'Chiudi dettaglio' : 'Apri dettaglio' }}</span>
                    </a>
                </ul>
            </div>
          </div>

          <div *ngIf="scadenza.appunto && scadenza.appunto.trim().length > 0" class="documento white">
            <p>{{ scadenza.appunto }}</p>
          </div>


          <!--<ngb-accordion [closeOthers]="true" #acc="ngbAccordion">
            <ngb-panel id="adempimentolistmember{{ i }}">
              <ng-template ngbPanelContent>
                <div class="row">
                  <div
                    labelTextInput
                    class="col-sm-4 bloccodati"
                    [typeLabel]="'text'"
                    [labelInput]="'Tipo'"
                    [valueInput]="scadenza.tipoScadenza?.label"
                  ></div>
                  <div
                    labelTextInput
                    class="col-sm-4 bloccodati"
                    [typeLabel]="'text'"
                    [labelInput]="'Adempimento'"
                    [valueInput]="scadenza.motivo?.label"
                  ></div>
                  <div
                    labelTextInput
                    class="col-sm-4 bloccodati"
                    [typeLabel]="'text'"
                    [labelInput]="'Priorit&agrave;'"
                    [valueInput]="scadenza.priorita?.label"
                  ></div>
                </div>
                <div class="row">
                  <div
                    labelTextInput
                    class="col-sm-4 bloccodati"
                    [typeLabel]="'dateTime'"
                    [labelInput]="'Data'"
                    [valueInput]="
                      scadenza.lastRinvioScadenza
                        ? scadenza.lastRinvioScadenza.dataA
                        : scadenza.dataScadenza
                    "
                  ></div>
                  <div
                    labelTextInput
                    class="col-sm-4 bloccodati"
                    [typeLabel]="'date'"
                    [labelInput]="'Data promemoria'"
                    [valueInput]="scadenza.dataPromemoria"
                  ></div>
                  <div
                    labelTextInput
                    class="col-sm-4 bloccodati"
                    [typeLabel]="'boolean'"
                    [labelInput]="'Pubblica'"
                    [valueInput]="scadenza.pubblica"
                  ></div>
                </div>
                <div class="row">
                  <div
                    labelTextInput
                    class="col-sm-4 bloccodati"
                    [typeLabel]="'boolean'"
                    [labelInput]="'Evaso'"
                    [valueInput]="scadenza.evasa"
                  ></div>
                  <div
                    labelTextInput
                    class="col-sm-4 bloccodati"
                    [typeLabel]="'date'"
                    [labelInput]="'Data evasione'"
                    [valueInput]="scadenza.dataEvasione"
                  ></div>
                  <div
                    labelTextInput
                    class="col-sm-4 bloccodati"
                    [typeLabel]="'text'"
                    [labelInput]="'Appunto'"
                    [valueInput]="scadenza.appunto"
                  ></div>
                </div>
                <div class="row">
                  <div class="col-sm-12 bloccodati">
                    <p>
                      <label class="col-sm-12">Note</label>
                      <span class="longtext">{{ scadenza.note }}</span>
                    </p>
                  </div>
                </div>
              </ng-template>
            </ngb-panel>
          </ngb-accordion>-->
          <div class="{{activeIndex === i ? 'collapsed' : 'collapse'}} rinvio" id="rinviotab1{{i}}">
            <ng-template [ngIf]="scadenza.lastRinvioScadenza && scadenza.rinvioScadenza.length > 0">
              <h4>Rinvio dal</h4>
              <p class="data">{{ scadenza.lastRinvioScadenza?.dataDa | dateformatter:'DD/MM/YYYY HH:mm'}}</p>
              <p class="link">
                <a href="javascript:void(0)"
                  (click)="openListRinviiModal(scadenza)">Vedi tutti</a>
              </p>
            </ng-template>
            <li>
              <div class="row">
                <div labelTextInput 
                  [ngClass]="scadenza.tipoScadenza?.id === 'ATTIVITA' ? 'col-sm-3 bloccodati' : 'col-sm-4 bloccodati'" 
                  [typeLabel]="'text'" [labelInput]="'Tipo'"
                  [valueInput]="scadenza.tipoScadenza?.label">
                </div>
                <div labelTextInput 
                  [ngClass]="scadenza.tipoScadenza?.id === 'ATTIVITA' ? 'col-sm-3 bloccodati' : 'col-sm-4 bloccodati'"
                  [typeLabel]="'text'" [labelInput]="'Adempimento'"
                  [valueInput]="scadenza.motivo?.label">
                </div>
                <div labelTextInput 
                  [ngClass]="scadenza.tipoScadenza?.id === 'ATTIVITA' ? 'col-sm-3 bloccodati' : 'col-sm-4 bloccodati'"
                  [typeLabel]="'text'" [labelInput]="'Priorit&agrave;'"
                  [valueInput]="scadenza.priorita?.label">
                </div>
                <div *ngIf="scadenza.tipoScadenza?.id === 'ATTIVITA'" labelTextInput class="col-sm-3 bloccodati"
                    [typeLabel]="'text'" [labelInput]="'Assegnatario'"
                    [valueInput]="scadenza?.assegnatario"></div>
              </div>
              <div class="row">
                <div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'dateTime'" [labelInput]="'Data'"
                  [valueInput]="
                    scadenza.lastRinvioScadenza
                      ? scadenza.lastRinvioScadenza.dataA
                      : scadenza.dataScadenza
                  "></div>
                <div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'date'" [labelInput]="'Data promemoria'"
                  [valueInput]="scadenza.dataPromemoria"></div>
                <div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'boolean'" [labelInput]="'Pubblica'"
                  [valueInput]="scadenza.pubblica"></div>
              </div>
              <div class="row">
                <div labelTextInput class="col-sm-3 bloccodati" [typeLabel]="'boolean'" [labelInput]="'Evaso'"
                  [valueInput]="scadenza.evasa"></div>
                <div labelTextInput class="col-sm-3 bloccodati" [typeLabel]="'date'" [labelInput]="'Data evasione'"
                  [valueInput]="scadenza.dataEvasione"></div>
                <div  labelTextInput class="col-sm-3 bloccodati" [typeLabel]="'text'" [labelInput]="'Motivo evasione'"
                  [valueInput]="scadenza.motivoEvasione?.descrizione"></div>
                <div labelTextInput class="col-sm-3 bloccodati" [typeLabel]="'text'" [labelInput]="'Appunto'"
                  [valueInput]="scadenza.appunto"></div>
              </div>
              <div class="row">
                <div class="col-sm-12 bloccodati">
                  <p>
                    <label class="col-sm-12">Note</label>
                    <span class="longtext">{{ scadenza.note }}</span>
                  </p>
                </div>
              </div>
              <div class="row mr-5">
                <p class="col-sm-3 col-sm-offset-9 col-xs-4" style="right: 1%;">
                  <button type="button" class="btn btn-primary btn-block" (click)="onEdit(i)" >Modifica dati</button>
                </p>
              </div>
            </li>
            <div class="row container_fieldset" style="margin-left: unset !important; margin-right:unset !important;" *ngIf="scadenza.tipoScadenza?.id === 'UDIENZA' && scadenza.dettaglioEsitoAdempimento">
              <div class="col-sm-12">
                <fieldset class="form-group">
                  <legend>Esito Udienza</legend>
                    <div class="row">
                    <div class="col-sm-12">				
                      <table class="table-striped table">
                        <caption class="sr-only">Tabella esito udienza</caption>
                        <tbody>
                          <tr>
                            <th style="width: 25%;">Tipo provvedimento</th>
                            <th style="width: 25%;">Esito</th>
                            <th style="width: 10%;">Numero esito</th>
                            <th style="width: 10%;">Anno esito</th>
                            <th style="width: 25%;">Data pubblicazione</th>
                            <th style="width: 5%;"></th>
                          </tr>
                          <tr>
                            <td style="width: 25%;">{{ scadenza?.dettaglioEsitoAdempimento?.tipoEsito?.descrizione }}</td>
                            <td style="width: 25%;">{{ scadenza?.dettaglioEsitoAdempimento?.esitoDescrizione }}</td>
                            <td style="width: 10%;">{{ scadenza?.dettaglioEsitoAdempimento?.numeroEsito }}</td>
                            <td style="width: 10%;">{{ scadenza?.dettaglioEsitoAdempimento?.annoEsito }}</td>
                            <td style="width: 25%;">{{ scadenza?.dettaglioEsitoAdempimento?.dataPubblicazione | date:'dd/MM/yyyy'}}</td>
                            <td style="width: 5%;">
                              <div class="data_opzioni classificazione" style="position: relative; margin-right: 30%;">
                              <ul>
                                <li class="opzioni" appDropdownFocus>
                                <a class="dropdown-toggle"
                                  data-toggle="dropdown" href="#" role="button"
                                  aria-haspopup="true" aria-expanded="false">
                                  Opzioni<span class="glyphicon glyphicon-option-vertical"></span>
                                </a>
                                <div class="dropdown-menu">
                                  <ul>
                                    <li>
                                      <span class="glyphicon glyphicon-pencil"></span>
                                      <a href="javascript:void(0);" 
                                        (click)="onClickDropDownEvent({eventType: 'modificaDettaglioUdienza', scadenza: scadenza, index: i})">Modifica</a>
                                    </li>
                                    <li>
                                      <span class="glyphicon glyphicon-trash"></span>
                                      <a href="javascript:void(0)" 
                                      (click)="onClickDropDownEvent({eventType: 'eliminaDettaglioUdienza', scadenza: scadenza, index: i})">Elimina</a>
                                    </li>
                                  </ul>
                                </div>
                                </li>
                              </ul>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>														
                    </div>										 
                  </div>
                </fieldset>
              </div>
            </div>
            <ng-template [ngIf]="scadenza.documenti?.length > 0">
                <p>Documentazione allegata</p>
                <ul documenti_allegati_lista="" [documenti]="scadenza.documenti"
                  [subdoc]="false" [nomeCampoId]="nomeCampoId"
                  [writable]="writable"
                  [fascicolo]="fascicolo"
                  (onReturn)="onReturnUpdateCallback($event)"
                  (openModal)="showUploadNewVersionModal($event)"
                  (openHistoryModal)="showHistoryModal($event)"
                  (removDoc)="removeDoc($event, scadenza.id)"
                  (onOpenUpdateMetadatiModal)="displayDocUpdateMetadatiModal($event)">
                </ul>
            </ng-template>
          </div>
        </li>
      </ul>

  </div>
  <div class="tab-content" *ngIf="scadenze == null || scadenze.length == 0">
    <p>Nessun adempimento è stato ancora inserito.</p>
  </div>
</div>
<div modale_list_rinvii_scadenza [attr.id]="'modallistrinviiscad'" #modaleListRinviiScadenza></div>